import { dashboardRoutes as adminDashboardRoutes } from "@/plugins/router/routes/dashboard";
import { dashboardRoutes as userDashboardRoutes } from "@/plugins/router/routes/dashboardusers";

import { nutritionistsRoutes } from "@/plugins/router/routes/nutritionists";
import { structuresRoutes } from "@/plugins/router/routes/structures";
import { authRoutes } from "@/plugins/router/routes/auth";
import { userGroupsRoutes } from "@/plugins/router/routes/userGroups";
import { evaluationsRoutes } from "@/plugins/router/routes/evaluations";
import { patientsRoutes } from "@/plugins/router/routes/patients";
import { activityRoutes } from "@/plugins/router/routes/activities";
import { userRoutes } from "@/plugins/router/routes/users";
import { reportsRoutes } from "@/plugins/router/routes/reports";
import { alarmNoificationsRoutes } from "@/plugins/router/routes/alarmNotifications";
import { biaScheduleRoutes } from "@/plugins/router/routes/biaSchedule";
import { patientFormsRoutes } from "@/plugins/router/routes/patientForms";

const routes = [
  ...adminDashboardRoutes,
  ...userDashboardRoutes,
  ...nutritionistsRoutes,
  ...structuresRoutes,
  ...authRoutes,
  ...userGroupsRoutes,
  ...evaluationsRoutes,
  ...patientsRoutes,
  ...activityRoutes,
  ...userRoutes,
  ...reportsRoutes,
  ...alarmNoificationsRoutes,
  ...biaScheduleRoutes,
  ...patientFormsRoutes,

  {
    path: "*",
    redirect: "/login",
  },
];

export default routes;
